// extracted by mini-css-extract-plugin
module.exports = {"Blog":"Blogs_Blog__2NDdP"};